'use strict';

angular.module('Syrinscape.directives', [])
	.directive('appVersion', ['version', function(version) {
		return function(scope, elm, attrs) {
			elm.text(version);
		};
	}])
	.directive('controlsGridLayout', function($window) {
		return {
			restrict: 'A',
			link: function(scope, element) {
				var initial_element_padding = 15;

				scope.element_padding = initial_element_padding;

				var elements_seen = [];

				var define_padding = _.debounce(function(child_element) {
					if (
						!scope.selected_soundset ||
						!scope.selected_soundset.elements ||
						!scope.selected_soundset.elements.length ||
						(!child_element && !elements_seen.length)
					) {
						scope.element_padding = initial_element_padding;
						return;
					}
					child_element = child_element || _.first(elements_seen);
					if (!child_element) {
						return;
					}
					var parent_width = element.innerWidth();
					var element_width = child_element.width() + (initial_element_padding * 2);
					var column_count = Math.floor(parent_width / element_width);
					var column_remainder = parent_width % element_width;
					if (column_count === 1) {
						// Center single columns
						scope.element_padding = Math.floor(column_remainder / 2);
					} else {
						// Equally space out multiple columns
						var element_padding = initial_element_padding + Math.floor(Math.floor(column_remainder / column_count) / 2);
						// Decrement the padding to circumvent some rounding weirdness
						element_padding -= 1;
						scope.element_padding = element_padding;
					}

					// If the call to `define_padding` was debounced force
					// an update of the scope
					if (!scope.$$phase) {
						scope.$apply();
					}
				}, 100);

				scope.$watchCollection('panels', function() {
					// Wrap the call in a function so that no arguments are passed in
					define_padding()
				});

				scope.$watch('elementSize', function() {
					// Wrap the call in a function so that no arguments are passed in
					define_padding()
				});

				scope.controls_grid_layout_item_added = function(element) {
					if (!_.includes(elements_seen, element)) {
						elements_seen.push(element);
						define_padding(element);
					}
				};

				scope.controls_grid_layout_item_removed = function(element) {
					_.remove(elements_seen, element);
					define_padding();
				};

				var window_resize_event = 'resize.controlsGridLayout';

				$($window).on(window_resize_event, function() {
					define_padding();
				});

				// Remove any non-angular event bindings
				scope.$on('$destroy', function() {
					$($window).off(window_resize_event);
				});
			}
		};
	})
	.directive('controlsGridLayoutItem', function() {
		return {
			restrict: 'A',
			link: function(scope, element) {
				scope.controls_grid_layout_item_added(element);
				scope.$on('$destroy', function() {
					scope.controls_grid_layout_item_removed(element)
				});
			}
		};
	})
	.directive('manualOverride', function(user, utils) {
		return {
			restrict: 'E',
			templateUrl: context.urls.STATIC_URL + 'master/frontend/html_partials/_manual_override.html?gc=' + context.GIT_COMMIT,
			scope: {
				obj: '=',
				minProp: '@',
				maxProp: '@',
				valueProp: '@',
				valueName: '@',
				onApply: '=',
				formatted: '=',
				useMeasurementSystem: "=",
			},
			link: function(scope) {
				scope.values = {};

				scope.toggleOverride = function() {
					if (!scope.collapsed) {
						if (scope.minProp) {
							scope.values.min = convert_to_measurement_system(scope.obj[scope.minProp]);
						}
						if (scope.maxProp) {
							scope.values.max = convert_to_measurement_system(scope.obj[scope.maxProp]);
						}
						if (scope.valueProp) {
							scope.values.value = convert_to_measurement_system(scope.obj[scope.valueProp]);
						}
					}
					scope.collapsed = !scope.collapsed;
				};

				scope.applyOverride = function() {
					if (scope.values.min !== undefined) {
						scope.obj[scope.minProp] = convert_from_measurement_system(scope.values.min);
					}
					if (scope.values.max !== undefined) {
						scope.obj[scope.maxProp] = convert_from_measurement_system(scope.values.max);
					}
					if (scope.values.value !== undefined) {
						scope.obj[scope.valueProp] = convert_from_measurement_system(scope.values.value);
					}
					if (_.isFunction(scope.onApply)) {
						scope.onApply()
					}
					scope.toggleOverride();
				};

				function convert_to_measurement_system(val) {
					if (
						scope.useMeasurementSystem
						&& val
						&& user.measurement_system === context.IMPERIAL_MEASUREMENT_SYSTEM
					) {
						return utils.convert_metres_to_feet(val);
					} else {
						return val;
					}
				}

				function convert_from_measurement_system(val) {
					if (
						scope.useMeasurementSystem
						&& val
						&& user.measurement_system === context.IMPERIAL_MEASUREMENT_SYSTEM
					) {
						return utils.convert_feet_to_metres(val);
					} else {
						return val;
					}
				}
			}
		};
	})
	.directive('slider', function () {
		var _identifier = 1;

		return {
			restrict: "A",
			link: function(scope, elm, attrs) {
				// Single value sliders use `ngModel`, range value sliders use `ngModelMin` and `ngModelMax`.
				var is_single_value_slider = attrs.ngModel;

				// Each slider instance uses uniquely namespaced events so that
				// we can tear down event handlers when the slider's scope is removed
				var directiveId = _identifier++;
				var slideEvent = 'slide.slider-' + directiveId;
				var slideStopEvent = 'slideStop.slider-' + directiveId;
				var slideStartEvent = 'slideStart.slider-' + directiveId;

				// Init slider widget lib
				var opts = scope.$eval(attrs.slider);
				opts.value = get_model_value();
				var slider = elm.bootstrapSlider(opts);

				function get_model_value() {
					// Gets value(s) from the parent scope

					if (is_single_value_slider) {
						return scope.$eval(attrs.ngModel);
					} else {
						var min_value = scope.$eval(attrs.ngModelMin);
						var max_value = scope.$eval(attrs.ngModelMax);
						if (
							min_value === null || max_value === null
							|| min_value === undefined || max_value === undefined
						) {
							// We're having problems debugging remote issues originating from here,
							// so we're adding as much context as possible to the errors. In this case,
							// we're attempting to walk up the min+max properties and work out what
							// their parents are
							function get_context_from_scope(var_name) {
								var context = '';
								var tokens = var_name.split('.').slice(0, -1);
								var accum = [];
								_.forEach(tokens, token => {
									accum.push(token);
									var accum_var_name = accum.join('.');
									var accum_var_value = scope.$eval(accum_var_name);
									if (_.isObject(accum_var_value)) {
										var relevant_values = ['' + accum_var_value];
										if ('pk' in accum_var_value) { relevant_values.push('pk: ' + accum_var_value.pk); }
										if ('id' in accum_var_value) { relevant_values.push('id: ' + accum_var_value.id); }
										if ('url' in accum_var_value) { relevant_values.push('url: ' + accum_var_value.url); }
										accum_var_value = '[[ ' + relevant_values.join(' | ') + ' ]]';
									}
									context += accum_var_name + ': ' + accum_var_value + '. ';
								});
								return context;
							}
							var min_context = get_context_from_scope(attrs.ngModelMin);
							var max_context = get_context_from_scope(attrs.ngModelMax);

							throw new Error(
								`Invalid slider range values. Min: ${attrs.ngModelMin}=${min_value}. Max: ${attrs.ngModelMax}="${max_value}". Slider: ${attrs.slider}=${JSON.stringify(opts)}. Min context { ${min_context} }. Max context { ${max_context} }.`
							);
						}
						return [min_value, max_value];
					}
				}

				function set_model_value(value) {
					// Set values in the parent scope

					if (is_single_value_slider) {
						scope.$eval(attrs.ngModel + " = " + value);
					} else {
						scope.$eval(attrs.ngModelMin + " = " + _.min(value));
						scope.$eval(attrs.ngModelMax + " = " + _.max(value));
					}
				}

				function set_slider_value() {
					// Match the slider value to the scope value

					var value = get_model_value();
					if (
						_.isArray(value)
						&& (
							value[0] === undefined
							|| value[1] === undefined
							|| value[0] === null
							|| value[1] === null
						)
					) {
						// Bail if the range values appear to be broken
						return;
					}
					slider.bootstrapSlider('setValue', value);
				}

				var disable_watch = false;
				var is_sliding = false;

				// Sets value(s) on the slider when the selected element is changed
				_.each(['ngModel', 'ngModelMin', 'ngModelMax'], function(attr) {
					if (attrs[attr]) {
						scope.$watch(attrs[attr], function(newValue, oldValue) {
							// Only update the slider's value if the watch is not disabled
							// and the user is not interacting with it.
							if (!disable_watch && !is_sliding &&
									newValue !== null && newValue !== undefined) {
								set_slider_value();
							}
						}, true);
					}
				});

				// Disable slider when input is disabled.
				scope.$watch(
					function() {
						return elm.prop('disabled');
					},
					function(disabled) {
						elm.bootstrapSlider(disabled ? 'disable' : 'enable')
					}
				);

				elm.on(slideStartEvent, function(e) {
					is_sliding = true;
					// Evaluate ng-slide-start attribute.
					if (attrs.ngSlideStart) {
						scope.$eval(attrs.ngSlideStart)
					}
				});

				if (attrs.sliderOnChange) {
					var onChange = scope.$eval(attrs.sliderOnChange);
					elm.on('change', function(e) {
						onChange(e.value.newValue);
					});
				}

				elm.on(slideStopEvent, function(e) {
					is_sliding = false;
					var value = e.value;
					// Set model value from slider value again, because might have been
					// changed while the user is still holding the mouse down but not
					// actually sliding.
					set_model_value(value);
					// Evaluate ng-slide-stop attribute.
					if (attrs.ngSlideStop) {
						scope.$eval(attrs.ngSlideStop)
					}
					// Extra callback from options.
					if (opts.slideStopCallback) {
						opts.slideStopCallback(elm, value);
					}
				});

				elm.on(slideEvent, function slide_callback(e) {
					var value = e.value;
					set_model_value(value);
					// Evaluate ng-slide attribute.
					if (attrs.ngSlide) {
						scope.$eval(attrs.ngSlide)
					}
					// Extra callback from options.
					if (opts.slideCallback) {
						opts.slideCallback(elm, value);
					}
				});

				scope.$on('$destroy', function() {
					elm.off(slideEvent);
					elm.off(slideStartEvent);
					elm.off(slideStopEvent);
				});
			}
		};
	})
	// Disable input, select and textarea elements when fieldset is disabled.
	.directive('fieldset', function() {
		return {
			restrict: "E",
			link: function(scope, element, attrs) {
				scope.$watch(
					function() {
						return element.prop('disabled')
					},
					function(disabled) {
						element
							.find('input, select', 'textarea')
							.prop('disabled', disabled)
							// .find('input[slider]')
							// .slider(disabled ? 'disable' : 'enable')
						;
					}
				);
			}
		};
	})
	// Watches variable changes and collapse showen event to adjust collapse inner body mas height
	.directive('collapseHeight', function() {
		return {
			restrict: "A",
			link: function( scope, elem, attrs ) {

				// When panel visibility changes, heights need to calculated to ensure scrolling functions
				scope.$watch('panels.sl + panels.si', function() {
					adjust_heights();
				});

				// Window resize event
				scope.$on('resize::resize', function() {
					adjust_heights();
				});

				// Adjusts max height of the .accordion-body so pannel headings are always visible
				var adjust_heights = function() {
					var container = $('.property-inspector');
					var contents = $('#editor_section');
					var container_bottom = container.offset().top + container.outerHeight();
					var contents_top = contents.offset().top;
					var height_available = container_bottom - contents_top;
					contents.css('height', height_available + 'px');
				};
			}
		}
	})
	// Javascript resize event to Angular scope event for window resize.
	.directive('resize', function($window) {
		var _identifier = 1;
		return {
			link: function(scope) {
				var directiveId = _identifier++;
				var resizeEvent = 'resize.resize-directive-' + directiveId;

				function resizes() {
					// Namespacing events with name of directive + event to avoid collisions
					scope.$broadcast('resize::resize');
				}
				// avoid costly calculations while the window size is in flux
				var lazyLayout = _.debounce(resizes, 200);
				var windowElement = angular.element($window);
				windowElement.on(resizeEvent, lazyLayout);
				scope.$on('$destroy', function() {
					windowElement.off(resizeEvent);
				});
			}
		}
	})
	.directive('imageonload', function() {
	    return {
	        link: function(scope, element, attrs) {
	            element.bind('load', function() {
	                scope.$emit('imageonload::imageonload');
	            });
	        }
	    };
	})
	.directive('resizePlayerUiMain', function() {
		return {
			link: function(scope, elem) {
				var alerts = $('.js-alerts-container');

				function adjust_height() {
					var alerts_top = alerts.offset().top;
					var alerts_bottom = alerts_top + alerts.outerHeight();
					var desired_height = window.innerHeight - alerts_bottom;
					elem.css('height', desired_height + 'px');
					$('.right-col.search').css('height', desired_height + 'px')
				}

				scope.$on('resize::resize', function() {
					adjust_height();
				});

				scope.$watch('non_dismissable_alerts', function() {
					_.delay(function() { adjust_height() }, 500, 'later');
				});

				adjust_height();
			}
		}
	})
	.directive('toggleSoundsetArtwork', function() {
		return {
			link: function(scope, elem) {
				var visualisationsContainer = $('.visualisations-container')

				// Hide `.soundset-artwork` if height >= 30% of viewport height
				function toggleArtwork() {
					if (window.innerHeight >= 700) {
						if (elem.hasClass('hide-artwork-vis')) {
							// Show the element so we can measure its height
							elem.removeClass('hide-artwork-vis')
						}

						// Only update the artwork element that is actually in use
						// i.e. the one that has a computed height (not auto or 0)
						if (elem[0].offsetHeight > 0) {
							if (elem[0].offsetHeight > window.innerHeight * 0.3) {
								elem.add(visualisationsContainer).addClass('hide-artwork-vis')
							} else {
								elem.add(visualisationsContainer).removeClass('hide-artwork-vis')
							}
						}
					}
				}

				// Window resize event
				scope.$on('resize::resize', function () {
					toggleArtwork();
				});

				// When soundsets visibility changes
				scope.$watch('showsoundsets', function () {
					toggleArtwork()
				})

				toggleArtwork();
			}
		}
	})
	.directive('ensureLibraryListHeight', function() {
		var _identifier = 1;
		return {
			restrict: 'A',
			scope: {
				ensureLibraryListHeight: '@'
			},
			link: function(scope, elem) {
				var directiveId = _identifier++;

				var clickEvent = 'click.ensureLibraryListHeight.' + directiveId;
				var resizeEvent = 'resize.ensureLibraryListHeight.' + directiveId;

				var library = $('.library');
				var libraryHeader = library.find('h3');
				var libraryAccordionHeaders = library.find('.accordion-heading');

				var target = $(scope.ensureLibraryListHeight);
				var list = target.find('.library-container');
				var listSiblings = list.siblings();

				var getAvailableHeight = function() {
					var libraryHeight = library.outerHeight();
					var libraryHeaderHeight = libraryHeader.outerHeight();
					var libraryAccordionHeadersHeight = 0;
					libraryAccordionHeaders.each(function() {
						libraryAccordionHeadersHeight += $(this).outerHeight() || 0;
					});
					var listSiblingsHeight = 0;
					listSiblings.each(function() {
						var sibling = $(this);
						if (sibling.is(':visible')) {
							listSiblingsHeight += sibling.outerHeight() || 0;
						}
					});
					return libraryHeight - libraryHeaderHeight - libraryAccordionHeadersHeight - listSiblingsHeight;
				};

				var setChildHeight = function() {
					if (!target.hasClass('collapsed')) {
						list.css('max-height', getAvailableHeight());
					}
				};

				// added for when the samples edit box appear on sample select
				// we need to recaculate the heights
				// scope.$watch(function() {
				//     return elem.is(':visible') && elem.hasClass('selected-sample-info');
				// }, function() {
				// 	setChildHeight();
				// });

				elem.on(clickEvent, function() {
					target.on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', setChildHeight);
				});

				$(window).on(resizeEvent, _.debounce(setChildHeight, 75));

				scope.$on('$destroy', function() {
					elem.off(clickEvent);
					$(window).off(resizeEvent);
				});
			}
		};
	})
	.directive('scrolledPagination', function() {
		const SCROLL_BUFFER = 2; // Proportion of elem height we want to be available for scrolling

		var _identifier = 1;
		return {
			restrict: 'A',
			link: function(scope, elem, attrs) {
				var scrolledPagination = scope.$eval(attrs.scrolledPagination);
				var directiveId = _identifier++;
				var scrollEvent = 'scroll.scrolledPagination-' + directiveId;

				elem.on(scrollEvent, _.throttle(function() {
					if (
						scrolledPagination.next_page &&
						!scrolledPagination.loading &&
						elem.prop('scrollTop') + SCROLL_BUFFER * elem.height() >= elem.prop('scrollHeight')
					) {
						scrolledPagination.get_next_page();
					}
				}, 33));

				// Get next page if elem is not yet scrollable but more results exist
				const observer = new MutationObserver(function (
					mutationsList,
					observer
				) {
					scope.$apply(function () {
						if (
							scrolledPagination.next_page &&
							!scrolledPagination.loading &&
							SCROLL_BUFFER + elem.height() >= elem.prop('scrollHeight')
						) {
							scrolledPagination.get_next_page();
						}
					});
				});

				observer.observe(elem[0], {
					childList: true,
				});

				scope.$on('$destroy', function() {
					elem.off(scrollEvent);
					observer.disconnect();
				});
			}
		};
	})
	.directive('scrollTopOnChange', function() {
		return {
			restrict: 'A',
			link: function(scope, elem, attr) {
				var scrollToTop = _.debounce(function () {
					elem.prop('scrollTop', 0);
				}, 100, {leading: true});

				attr.$observe('scrollTopOnChange', scrollToTop);
			}
		};
	})
	.directive('uploadDropZone', function() {
		return {
			restrict: 'A',
			scope: {
				onFilesSelected: '='
			},
			link: function(scope, elem, attr) {
				var onFilesSelected = scope.onFilesSelected;
				if (!onFilesSelected || !(onFilesSelected instanceof Function)) {
					throw new Error('`on-files-selected` not defined or is not a function');
				}

				var inDragover = false;

				// Used for handling click events on the label
				var input;
				function reset_input() {
					if (input) {
						input.remove();
					}
					input = $('<input class="upload-drop-zone-file-input js-upload-drop-zone-file-input" type="file" multiple>');
					elem.append(input);
				}
				reset_input();

				elem.on('dragover', function(ev) {
					// Prevent default behavior (Prevent file from being opened)
					ev.preventDefault();

					if (!inDragover) {
						inDragover = true;
						elem.addClass('upload-drop-zone--dragover');
					}
				});

				elem.on('dragleave', function(ev) {
					// Prevent default behavior (Prevent file from being opened)
					ev.preventDefault();

					if (inDragover) {
						inDragover = false;
						elem.removeClass('upload-drop-zone--dragover');
					}
				});

				elem.on('drop', function(ev) {
					// Prevent default behavior (Prevent file from being opened)
					ev.preventDefault();

					var dataTransfer = ev.originalEvent.dataTransfer;
					var files = [];

					if (dataTransfer.items) {
						// Use DataTransferItemList interface to access the file(s)
						for (var i = 0; i < dataTransfer.items.length; i++) {
							// If dropped items aren't files, reject them
							if (dataTransfer.items[i].kind === 'file') {
								var file = dataTransfer.items[i].getAsFile();
								files.push(file);
							}
						}
					} else {
						// Use DataTransfer interface to access the file(s)
						for (var i = 0; i < dataTransfer.files.length; i++) {
							files.push(dataTransfer.files[i]);
						}
					}

					onFilesSelected(files);
				});

				elem.on('change', '.js-upload-drop-zone-file-input', function(ev) {
					var files = [];
					for (var i=0; i < this.files.length; i++) {
						files.push(this.files[i]);
					}

					onFilesSelected(files);

					// Replace the input after selections to get around browser limitations
					// that prevent uploading the same file twice
					reset_input();
				});
			}
		};
	})
	// Bootstrap's tooltip
	.directive('tooltip', function () {
		return {
			restrict: "A",
			link: function(scope, elem, attrs) {
				var options;
				if (attrs) {
					options = scope.$eval(attrs.tooltip);
				}
				var initial_options = _.assign({}, options, {
					title: function() {
						// Handle cases where the tooltip's title may have changed
						// since the directive's init
						var current_options = scope.$eval(attrs.tooltip);
						return current_options.title;
					}
				});
				elem.tooltip(initial_options);
			}
		};
	})
	.directive('trackFocus', function () {
		return {
			restrict: "A",
			link: function(scope, elem, attrs) {
				var obj = scope.$eval(attrs.trackFocusObject);
				var prop = attrs.trackFocusProperty;

				elem.on('focus', function() {
					scope.handle_property_has_focused(obj, prop);
				});

				elem.on('blur', function() {
					scope.handle_property_has_blurred(obj, prop);
				});
			}
		};
	})
;



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/directives.js